import { Box, Flex, Text } from '@/ui';
import { GradientCrown } from '@/ui/Icon/GradientCrown';

type Props = {
  title: string;
  description: string;
};

// Inset note explaining that Plus access is granted by a workspace rather than
// bought on the personal account. Used on the personal panel (access inherited
// from an org/family) and on a member's workspace panel.
export const InheritedAccessNote = ({ title, description }: Props) => (
  <Flex align="center" bg="gray.100" borderRadius="ah-lg" gap="3" p="3">
    <Flex
      align="center"
      bg="white"
      borderColor="gray.200"
      borderRadius="ah-md"
      borderWidth="1px"
      boxSize="8"
      flexShrink={0}
      justify="center"
    >
      <GradientCrown boxSize="4" />
    </Flex>
    <Box lineHeight="short" minW="0">
      <Text fontWeight="semibold">{title}</Text>
      <Text color="customgray.mid" fontSize="sm">
        {description}
      </Text>
    </Box>
  </Flex>
);
